import { Box, Typography } from "@mui/material";
import QRIcon from "assets/icons/qr_icon.svg";
import { QRList } from "lib/features/qrList/types";
import { myQRListStyles } from "styles/QRListDirectory/myqrList.styles";

interface BusinessCardProps {
  qrcode: QRList;
  setSelectedQR: React.Dispatch<React.SetStateAction<QRList | undefined>>;
}

const QRListItem = ({ qrcode, setSelectedQR }: BusinessCardProps) => {
  return (
    <Box
      sx={myQRListStyles.qrListCard}
      onClick={() => {
        setSelectedQR(qrcode);
      }}
    >
      <img src={QRIcon} alt="qr-icon" />
      <Box sx={myQRListStyles.qrListContainer}>
        <Typography sx={myQRListStyles.qrListMainText}>
          {qrcode.qr_name}
        </Typography>

        <Box sx={myQRListStyles.qrListDetailsCard}>
          <Typography sx={myQRListStyles.qrListSubText}>List: </Typography>
          <Typography sx={myQRListStyles.qrListText}>
            {qrcode?.business_list?.list_name ??
              "List has not been assigned yet"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default QRListItem;
